import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Lightbox from './Lightbox';

const galleryImages = [
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/744e5944-e504-4454-9f4f-5325c6999fa8_compressed_F5E3E739-2C7B-401F-AAC7-7110DF8776C9.webp',
    alt: 'Casa De la Villaflor - Private heated pool with turquoise water and sunny terrace',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/56e47e9b-f58d-4d0e-a7f2-e168252a2802_compressed_9E6D3482-7D4D-4B57-B575-072FBF6EC93F-4.webp',
    alt: 'Casa De la Villaflor - Master bedroom with king bed and terrace access',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/daa66e83-6fd0-4cfd-b58c-c1ff1405a63f_compressed_B2D0D63F-9A55-42F5-88FA-2063307D3FE2-3.webp',
    alt: 'Casa De la Villaflor - Twin bedroom with two single beds and wooden headboards',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/2c368793-6bae-4543-84ef-a85323d9cad1_compressed_PHOTO-2026-08-05-11-52-47.webp',
    alt: 'Casa De la Villaflor - Bathroom with blue tiles and walk-in shower',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/1f5a5584-9e39-4807-a6a9-047d42724b07_compressed_cocinamejorada.webp',
    alt: 'Casa De la Villaflor - Fully equipped kitchen with modern appliances',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/b38713ff-c51d-4ef1-a7fc-7831879958fa_compressed_barbacoa-.webp',
    alt: 'Casa De la Villaflor - Outdoor BBQ area with grill and terrace',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/ef895c6f-0c55-45da-b1d2-3cefef6d0ae4_compressed_19517A3D-465B-4A5C-8F1D-756746AE0C91-4.webp',
    alt: 'Casa De la Villaflor - Interior hallway with decorative cabinet and warm lighting',
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/5faba352-eac1-4c2c-9c95-67c7c7abde42_compressed_B01B16F4-D22C-450F-96DE-83C7F92202C1-4.webp',
    alt: 'Casa De la Villaflor - Antique wooden cabinet in the living area',
  },
];

export default function VillaflorGallery() {
  const { t } = useTranslation();
  const [lightboxIndex, setLightboxIndex] = useState<number>(-1);

  const handlePrev = () => {
    setLightboxIndex((prev) => (prev > 0 ? prev - 1 : galleryImages.length - 1));
  };

  const handleNext = () => {
    setLightboxIndex((prev) => (prev < galleryImages.length - 1 ? prev + 1 : 0));
  };

  return (
    <section id="gallery" className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">{t('gallery_subtitle')}</p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950">{t('gallery_title')}</h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className="break-inside-avoid mb-4 md:mb-5 rounded-lg overflow-hidden cursor-pointer group relative"
              onClick={() => setLightboxIndex(i)}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                <span className="w-10 h-10 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform scale-75 group-hover:scale-100">
                  <i className="ri-zoom-in-line text-xl"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightboxIndex >= 0 && (
        <Lightbox
          images={galleryImages}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxIndex(-1)}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      )}
    </section>
  );
}